export function PriceComparisonDiscountBadge({
	discountPercentage,
}: {
	discountPercentage?: number;
}) {
	if (!discountPercentage || Math.abs(discountPercentage) < 5) {
		return null;
	}

	return (
		<span className="text-caption text-orange-700 bg-orange-200 text-center self-end p-1 rounded-sm">
			<span>-{Math.round(Math.abs(discountPercentage))}%</span>
		</span>
	);
}
